import { render, staticRenderFns } from "./bsc.vue?vue&type=template&id=44e2dcfe&scoped=true"
import script from "./bsc.vue?vue&type=script&lang=js"
export * from "./bsc.vue?vue&type=script&lang=js"
import style0 from "./bsc.vue?vue&type=style&index=0&id=44e2dcfe&prod&scoped=true&lang=css"
import style1 from "./bsc.vue?vue&type=style&index=1&id=44e2dcfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2dcfe",
  null
  
)

export default component.exports